import React from 'react'

export default function FAQ() {
  return (
    <>
    <h3>FAQs</h3>
            <div className='today-faqs'>
            <h3>What is Future?</h3>

<p>A future is a contract to buy or sell an underlying stock or other assets at a pre-determined price on a specific date.</p>

<h3>What is option?</h3>

<p>A Option is contract that gives an opportunity to the investor the right but not the obligation to buy or sell the assets at a specific price on a specific date, known as the expiry date.</p>

<h3>What is future index?</h3>

<p>Index futures are contracts that allow a trader to purchase or sell a financial index today and sell on later date on or before underlying expiry date. Traders speculate on the price direction of an index, such as the Nifty future, Nifty 50 future, Bank nifty futures, IT index future etc.</p>



<h3>What is difference between futures and options?</h3>

<p>The prime difference between options and futures is that futures need the contract holder to purchase the underlying assets such as commodities or stocks on a respective date in the near future. Options, on the other hand, offer the contract holder the choice or option of executing the contract.</p>



<h3>What is future and option strategy?</h3>

<p>There are many futures and option strategies. Nearly 52 strategies are there for options. A straddle is options trading strategies. Here a trader buys both a call option and a put option on the same underlying asset with the same strike price and expiration date. A trader can make money with this strategy when prices move a lot in either direction.</p>



<h3>How to trade in future and options?</h3>



<p>To invest in futures and options, you would need an F&O Demat and trading account. To invest in futures, the investor pays a margin which is a portion of the total value of contract. Once the margin money is paid, the exchange matches your order with available buyers or sellers in the market.</p>



<h3>How to trade futures for beginners?</h3>



<ol>
	<li>First find the direction of major index like Nifty, Bank nifty.</li>
	<li>Find the best stock or index to go long or short as per direction analysis.</li>
	<li>Establish a trading plan. Plan your trades carefully before you establish a position.</li>
	<li>Protect your positions.</li>
	<li>Go slow. Means start first with 1 lot of any asset.</li>
	<li>Learn about technical analysis & then pace your trading.</li>
	<li>Think long and short both as per index direction.</li>
	<li>Don’t be in hurry. Market is not going anywhere.</li>
	<li>Be patient.</li>
</ol>



<h3>Is F&O and intraday same?</h3>



<p>No, Intraday trading is when you buy and sell stocks within the same day. F&O trading is when you buy and sell contracts that give you the right to buy or sell an asset at a predetermined price on a future date.</p>



<h3>Which is better option or future?</h3>

<p>The advantages of options over futures are well-documented. You can start option with very little money. The advantages of futures over options include their suitability for trading certain investments, fixed upfront trading costs, lack of time decay, liquidity, and easier pricing model. Generally big player, play in future market and sells options. While retail traders buy options.</p>



<h3>Is F&O trading profitable?</h3>

<p>In a research report brought out recently, markets regulator Sebi showed that the futures and options (F&O) trading was a loss-making proposition for investors. The report revealed that 89% investors lost money through these activities, and only 11% made profits.</p>



<h3>What derivative means?</h3>

<p>A derivative is a contract between two parties which derives its value/price from an underlying asset means cash price of asset. The most common types of derivatives are futures, options, forwards and swaps. It is a financial instrument which derives its value/price from the underlying assets. Generally big player use future and options to hedge the portfolio.</p>



<h3>Which is safe future or options?</h3>

<p>Futures and options trading both carry risks. Options contracts lose their value quickly due to strong theta decay and may result in a total loss if not exercised on time. Individual investors, however, face greater risk when investing in futures.</p>



<h3>Why option selling is best?</h3>

<p>Selling options can help generate income as premium upfront and hope the option expires worthless. Option sellers benefit as time passes and the option declines in value. In this way, the seller can book an offsetting trade at a lower premium and earns profits.</p>

            </div>
    </>
  )
}
